<span *ngFor="let item of items; let i = index" [ngSwitch]="item.type" class="kd-document-item" [ngClass]="{
    'kd-document-item--heading': item.type === contentItemType.Heading,
    'kd-document-item--pre': item.type === contentItemType.Pre,
    'kd-document-item--snippet': item.type === contentItemType.CodeSnippet || item.type === contentItemType.RequestSnippet,
    'kd-document-item--text': item.type === contentItemType.Text
}">
    <kd-document-code
        *ngSwitchCase="contentItemType.CodeSnippet"
        [element]="item.content"
        (click)="onSnippetClick($event)"
        (mouseover)="onSnippetOver($event)"
    ></kd-document-code>

    <kd-document-heading
        *ngSwitchCase="contentItemType.Heading"
        [element]="item.content"
        [index]="i"
    ></kd-document-heading>

    <kd-document-request
        *ngSwitchCase="contentItemType.RequestSnippet"
        [element]="item.content"
        (click)="onSnippetClick($event)"
        (mouseover)="onSnippetOver($event)"
    ></kd-document-request>

    <kd-document-text
        *ngSwitchCase="contentItemType.Pre"
        [content]="item.content"
    ></kd-document-text>

    <kd-document-text
        *ngSwitchCase="contentItemType.Text"
        [content]="item.content"
    ></kd-document-text>
</span>

<span class="template" [id]="snippetCredentialTemplateId">
    <div [ngClass]="snippetCredentialClass">
        <button
            type="button"
            [ngClass]="snippetCredentialClass + '__button'"
        >
            <span [ngClass]="snippetCredentialClass + '__body'"></span>
            <svg class="kd-icon--m" [ngClass]="snippetCredentialClass + '__warning'" kdSldsIcon="info"></svg>
        </button>

        <div
            class="slds-popover slds-popover--tooltip"
            [ngClass]="snippetCredentialClass + '__tooltip'"
        >
            <div
                class="slds-popover__body"
                [ngClass]="snippetCredentialClass + '__tooltip-body'"
            ></div>
        </div>
    </div>
</span>
